export const defaultStyle = {
    brandLabelWrapperOne: "brandLabelWrapperOne px-[20px] max-w-xl mx-auto ",
    brandLabelWrapper: 'brandLabelWrapper relative mb-50 px-[25px] text-right md:mb-[95px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto [&>div>p]:mx-[25px] ',
    brandFilterWrapper: 'brandFilterWrapper max-w-xl mx-auto relative ',
    brandFiltersList: 'brandFiltersList bg-[#4f2170] absolute top-[-44px] lg:top-[-92px] right-[26px] md:right-[35px] lg:right-[16px] md:top-[-90px] z-50 overflow-hidden cursor-pointer w-[210.03px] h-auto',

    brandFilterRow: 'brandFilterRow last:border-t-1 border-[#724D8D]',
    filterText: 'filterText text-white text-[18px] tracking-normal font-bold cursor pointer  px-30 py-7 ',
    brandSection: 'brandsMainWrapper flex flex-wrap text-center md:pb-70',
    brandWrapper: "w-1/2 md:w-4/12 lg:w-1/4 px-25 md:px-50 mb-45 md:mb-90",
    brandShapePic: 'brand-image-wrapper block w-full text-center',
    brandLink: 'brandLink relative block',
    brandImg: 'absolute top-[50%] left-[50%] w-[60%] -translate-x-2/4 -translate-y-2/4',
    title: 'text-16 md:text-28 text-black font-bold mt-25 mb-15',
}